:host {
  width: 100%;
  display: block;
}

.progress {
  position: relative;
  display: flex;
  width: 100%;
  height: 6px;
  overflow: hidden;
  font-family: 'On Air Var', sans-serif;
  font-size: 1.2rem;
  background-color: #e9ecef;
  border-radius: var(--border-radius, #{$border-radius});

  &.progress--radius-left-0 {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }

  &.progress--radius-right-0 {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
}

.progress--small {
  height: 6px;
}

.progress--medium {
  height: 18px;
}

.progress--large {
  height: 24px;
}

.progress-bar {
  display: flex;
  flex-direction: column;
  justify-content: center;
  color: #fff;
  text-align: center;
  white-space: nowrap;
  background-color: var(--o2-blue-action, #{$blue-action});
  transition: width 0.6s ease;

  &.progress-bar--primary {
    background-color: var(--o2-blue-action, #{$blue-action});
  }

  &.progress-bar--success {
    background-color: var(--o2-green, #{$green});
  }

  &.progress-bar--warning {
    background-color: var(--o2-orange, #{$orange});
  }

  &.progress-bar--danger {
    background-color: var(--o2-red, #{$red});
  }

  &.progress-bar--yellow {
    background-color: #ffd400;
  }

  &.progress-bar--cyan {
    background-color: var(--o2-green, #{$green});
  }

  &.progress-bar--empty {
    color: #bbb;
    margin-left: 5px;
  }
}

.progress-bar__text {
  position: absolute;
  left: 0;
  right: 0;
  height: 100%;
  display: flex;
  align-items: center;
  padding: 0 1.5rem;

  &.progress-bar__text--light {
    color: white;
  }

  &.progress-bar__text--dark {
    color: var(--o2-black, #{$black});
  }

  &.progress-bar__text--left {
    justify-content: flex-start;
  }

  &.progress-bar__text--right {
    justify-content: flex-end;
  }

  &.progress-bar__text--center {
    justify-content: center;
  }
}

@media (prefers-reduced-motion: reduce) {
  .progress-bar {
    transition: none;
  }
}
